import { Language } from '^/types';

export default {
  measurement: {
    [Language.KO_KR]: '측정 ',
    [Language.EN_US]: 'Measurement ',
  },
  overlay: {
    [Language.KO_KR]: '도면 ',
    [Language.EN_US]: 'Overlay ',
  },
  gcp: {
    [Language.KO_KR]: '지상기준점 ',
    [Language.EN_US]: 'GCP ',
  },
  tooltipCopy: {
    [Language.KO_KR]: '복사',
    [Language.EN_US]: 'Copy',
  },
  tooltipDelete: {
    [Language.KO_KR]: '삭제',
    [Language.EN_US]: 'Delete',
  },
  tooltipDownload: {
    [Language.KO_KR]: '다운로드',
    [Language.EN_US]: 'Download',
  },
  tooltipCenter: {
    [Language.KO_KR]: '원점',
    [Language.EN_US]: 'Center',
  },
  tooltipNavigateToPhotoAlbum: {
    [Language.KO_KR]: '사진첩으로 이동',
    [Language.EN_US]: 'Navigate to Photo Album',
  },
  issue: {
    [Language.KO_KR]: '작업 관리 ',
    [Language.EN_US]: 'Issue ',
  },
};
